import { useTranslation } from 'react-i18next';

export default function CasesSection() {
  const { t } = useTranslation();
  
  const gameProjects = [
    {
      name: "HAAK",
      type: t('platformActionGame'),
      icon: "https://static.readdy.ai/image/14090482ad00f674843640af3b243289/54ca0c40d9bd6cb1801336d427c47f45.png",
      background: "https://static.readdy.ai/image/14090482ad00f674843640af3b243289/c1199804a263aae177306d1e49085fc8.png",
      description: t('haakDescription'),
      result: t('monthlyRevenueGrowth'),
      color: "primary"
    },
    {
      name: "Muse Dash",
      type: t('musicRhythmGame'),
      icon: "https://static.readdy.ai/image/14090482ad00f674843640af3b243289/c0f841954ee82942b2504e12d95e51e2.png",
      background: "https://static.readdy.ai/image/14090482ad00f674843640af3b243289/abda7e25fcb679699233db508589775f.webp",
      description: t('museDashDescription'),
      result: t('playerReviews'),
      color: "blue"
    },
    {
      name: "Kristala",
      type: t('actionStealthGame'),
      icon: "https://static.readdy.ai/image/14090482ad00f674843640af3b243289/0fad9d8e8af305a9662690afc5595f2c.png",
      background: "https://static.readdy.ai/image/14090482ad00f674843640af3b243289/1a0fdea3977aab3850993fffc487e4fa.webp",
      description: t('kristalaDescription'),
      result: t('translationCompleted'),
      color: "primary"
    },
    {
      name: "Lazy Meow City",
      type: t('casualPuzzleGame'),
      icon: "https://static.readdy.ai/image/14090482ad00f674843640af3b243289/750971951dc2906f8984d7316a51ae03.jfif",
      background: "https://static.readdy.ai/image/14090482ad00f674843640af3b243289/641b79fb40589d134191aa7e5fce4f95.png",
      description: t('lazyMeowDescription'),
      result: t('salesIncrease'),
      color: "blue"
    },
    {
      name: "StoneSquad",
      type: t('roguelikeCardGame'),
      icon: "https://static.readdy.ai/image/14090482ad00f674843640af3b243289/6057b9ff9923c6ede780332acd06930b.png",
      background: "https://static.readdy.ai/image/14090482ad00f674843640af3b243289/e2e0f51b78b4abe178cf580eb933db90.png",
      description: t('stoneSquadDescription'),
      result: t('exposureGrowth'),
      color: "green"
    },
    {
      name: "CatHotel",
      type: t('simulationGame'),
      icon: "https://static.readdy.ai/image/14090482ad00f674843640af3b243289/278fd0b0e32698dfe9789de43d4c903e.png",
      background: "https://static.readdy.ai/image/14090482ad00f674843640af3b243289/f8b71f66895dccf689552be21ae0f3ec.png",
      description: t('catHotelDescription'),
      result: t('playerReviews2'),
      color: "purple"
    }
  ];

  const testimonials = [
    {
      name: "Sarah Chen",
      role: t('testimonialSarahRole'),
      avatar: "ri-user-smile-line",
      color: "blue",
      content: t('testimonialSarahContent')
    },
    {
      name: "Thijs Vermeer",
      role: t('testimonialThijsRole'),
      avatar: "ri-user-smile-line",
      color: "purple",
      content: t('testimonialThijsContent')
    },
    {
      name: "Emma Blackwood",
      role: t('testimonialEmmaRole'),
      avatar: "ri-user-smile-line",
      color: "green",
      content: t('testimonialEmmaContent')
    },
    {
      name: "David Liu",
      role: t('testimonialDavidRole'),
      avatar: "ri-user-smile-line",
      color: "yellow",
      content: t('testimonialDavidContent')
    },
    {
      name: "Alex Rodriguez",
      role: t('testimonialAlexRole'),
      avatar: "ri-user-smile-line",
      color: "red",
      content: t('testimonialAlexContent')
    },
    {
      name: "Yuki Tanaka",
      role: t('testimonialYukiRole'),
      avatar: "ri-user-smile-line",
      color: "indigo",
      content: t('testimonialYukiContent')
    }
  ];

  return (
    <section id="cases" className="py-20 px-6 bg-gray-950">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-indigo-400 text-xl mb-3">{t('casesSubtitle')}</h2>
          <h3 className="text-4xl font-bold mb-6 text-white">{t('casesTitle')}</h3>
          <p className="text-gray-300 max-w-2xl mx-auto">
            {t('casesDescription')}
          </p>
        </div>

        {/* Game Projects Grid */}
        <div className="grid grid-cols-2 lg:grid-cols-3 gap-8 mb-24">
          {gameProjects.map((project, index) => (
            <div 
              key={index}
              className="group relative rounded-xl p-6 overflow-hidden hover:shadow-xl transition-all duration-500 transform hover:-translate-y-2"
            >
              <div className="absolute inset-0 z-0">
                <img 
                  src={project.background} 
                  alt={`${project.name} Background`} 
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/50 to-transparent"></div>
              </div>
              
              <div className="relative z-10">
                <div className="flex items-center gap-4 mb-6">
                  <div className={`w-12 h-12 bg-${project.color === 'primary' ? 'indigo' : project.color}-500/10 backdrop-blur-sm rounded-xl flex items-center justify-center transform transition-transform duration-500 group-hover:rotate-12`}>
                    <img 
                      src={project.icon} 
                      alt={project.name} 
                      className="w-8 h-8 object-contain"
                    />
                  </div>
                  <div>
                    <h4 className="text-lg font-bold text-white">{project.name}</h4>
                    <p className="text-sm text-gray-300">{project.type}</p>
                  </div>
                </div>
                
                <p className="text-gray-200 mb-4">{project.description}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Stats and Testimonials */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-16 mb-24">
          {/* Stats */}
          <div className="bg-gray-900 rounded-xl p-8 relative group">
            <div className="absolute -inset-4 bg-gradient-to-r from-indigo-500/20 to-purple-600/20 rounded-2xl blur-lg opacity-0 transition-opacity duration-300 group-hover:opacity-100"></div>
            <div className="relative flex items-center mb-8">
              <div className="w-14 h-14 rounded-full bg-indigo-500/20 flex items-center justify-center mr-4 shadow-lg shadow-indigo-500/20">
                <i className="ri-line-chart-line ri-2x text-indigo-500"></i>
              </div>
              <div>
                <span className="text-indigo-400 text-sm font-medium">{t('successMetrics')}</span>
                <h4 className="text-2xl font-bold mt-1 text-white">{t('serviceImpact')}</h4>
              </div>
            </div>
            
            <div className="grid grid-cols-2 gap-6">
              <div>
                <div className="text-4xl font-bold mb-2 text-white">97%</div>
                <p className="text-gray-400">{t('clientSatisfactionRate')}</p>
              </div>
              <div>
                <div className="text-4xl font-bold mb-2 text-white">{t('translatedCharactersCount')}</div>
                <p className="text-gray-400">{t('translatedCharacters')}</p>
              </div>
              <div>
                <div className="text-4xl font-bold mb-2 text-white">80+</div>
                <p className="text-gray-400">{t('servicedCompanies')}</p>
              </div>
              <div>
                <div className="text-4xl font-bold mb-2 text-white">{t('avgTranslationSpeedValue')}</div>
                <p className="text-gray-400">{t('avgTranslationSpeed')}</p>
              </div>
            </div>
          </div>

          {/* Testimonials - Auto Scrolling Comments */}
          <div className="bg-gray-900 rounded-xl p-8 relative group">
            <div className="relative flex items-center gap-4 mb-8">
              <div className="w-12 h-12 rounded-xl bg-indigo-500/10 flex items-center justify-center">
                <i className="ri-message-3-line ri-xl text-indigo-500"></i>
              </div>
              <div>
                <h4 className="text-xl font-bold text-white">{t('customerReviews')}</h4>
                <p className="text-sm text-gray-400">{t('realUserFeedback')}</p>
              </div>
            </div>
            
            <div className="relative overflow-hidden h-[400px]">
              <div className="animate-testimonial space-y-4">
                {[...testimonials, ...testimonials].map((testimonial, index) => (
                  <div key={index} className="bg-gray-800/50 rounded-xl p-6 flex-shrink-0">
                    <div className="flex items-center gap-4 mb-4">
                      <div className={`w-12 h-12 rounded-full bg-${testimonial.color}-500/10 flex items-center justify-center`}>
                        <i className={`${testimonial.avatar} ri-lg text-${testimonial.color}-500`}></i>
                      </div>
                      <div>
                        <h5 className="font-medium text-white">{testimonial.name}</h5>
                        <p className="text-sm text-gray-400">{testimonial.role}</p>
                      </div>
                    </div>
                    <p className="text-gray-300 italic">"{testimonial.content}"</p>
                    <div className="flex items-center gap-1 mt-3">
                      {[...Array(5)].map((_, i) => (
                        <i key={i} className="ri-star-fill text-yellow-400"></i>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Partners */}
        <div className="text-center mb-16">
          <h2 className="text-indigo-400 text-xl mb-3">{t('partners')}</h2>
          <h3 className="text-4xl font-bold mb-6 text-white">{t('trustedPartners')}</h3>
          <p className="text-gray-300 max-w-2xl mx-auto">{t('partnersDescription')}</p>
        </div>

        <div className="relative overflow-hidden">
          <div className="relative w-full overflow-hidden before:absolute before:left-0 before:top-0 before:z-10 before:h-full before:w-[100px] before:bg-gradient-to-r before:from-gray-950 before:to-transparent after:absolute after:right-0 after:top-0 after:z-10 after:h-full after:w-[100px] after:bg-gradient-to-l after:from-gray-950 after:to-transparent">
            <div className="flex animate-scroll">
              {[
                "https://static.readdy.ai/image/14090482ad00f674843640af3b243289/036c6a2ba8d876b39cb3dac4e215d05d.png",
                "https://static.readdy.ai/image/14090482ad00f674843640af3b243289/774344ac8ca619f1893d6ba0c552e2e7.png",
                "https://static.readdy.ai/image/14090482ad00f674843640af3b243289/156bf214562b72539abdc94c38280b9f.png",
                "https://static.readdy.ai/image/14090482ad00f674843640af3b243289/7730fa063a029bc5ecd22fca56572158.png",
                "https://static.readdy.ai/image/14090482ad00f674843640af3b243289/fa02146daf17c1aa360d857da7f20a17.png"
              ].concat([
                "https://static.readdy.ai/image/14090482ad00f674843640af3b243289/036c6a2ba8d876b39cb3dac4e215d05d.png",
                "https://static.readdy.ai/image/14090482ad00f674843640af3b243289/774344ac8ca619f1893d6ba0c552e2e7.png",
                "https://static.readdy.ai/image/14090482ad00f674843640af3b243289/156bf214562b72539abdc94c38280b9f.png",
                "https://static.readdy.ai/image/14090482ad00f674843640af3b243289/7730fa063a029bc5ecd22fca56572158.png",
                "https://static.readdy.ai/image/14090482ad00f674843640af3b243289/fa02146daf17c1aa360d857da7f20a17.png"
              ]).map((logo, index) => (
                <div key={index} className="flex items-center justify-center min-w-[250px] px-8">
                  <div className="w-40 h-20 bg-black rounded-lg flex items-center justify-center group hover:bg-gray-900 transition-all duration-300">
                    <img 
                      src={logo} 
                      alt="Company Logo" 
                      className="w-full h-full object-contain p-4"
                    />
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
